import Navbar from '../component/Navbar';
import Footer from '../component/Footer';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from './Dropdown';
import Arrow from './Arrow';
import Generalsidebar from './Generalsidebar';

const Faq = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  const userInfo = JSON.parse(localStorage.getItem('userLoggedIn'))
    ? JSON.parse(localStorage.getItem('userLoggedIn'))
    : { firstName: '' };

  console.log('userInfo', userInfo);
  function handleArrowClick() {
    setShowSidebar(true);
  }

  return (
    <div>
      <Navbar />

      <div onClick={handleArrowClick} className='absolute top-24 left-12 z-20'>
        <Arrow />
      </div>
      <div className={showSidebar ? 'show-sidebar' : 'hidden'}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <div>
        <section
          className='flex items-center justify-center  h-64  bg-green-800/10 bg-no-repeat bg-cover relative'
          style={{
            backgroundImage:
              'url(https://res.cloudinary.com/dvcxb5tpj/image/upload/v1701082554/fitness_umnuah.jpg)',
          }}>
          <h1 className='uppercase font-bold text-2xl text-green-800/100'>
            Ask us any thing
          </h1>
          <div className='h-full w-full  bg-green-800/30 absolute top-0'></div>
        </section>
        <div className='bg-green-800/5 pb-10'>
          <div className='grid grid-cols-1 md:grid-cols-2 w-[90%] mx-auto '>
            <img
              src='https://res.cloudinary.com/dvcxb5tpj/image/upload/v1701169803/Question_mark_crq0cl.png'
              alt='mark'
              shadow-md
            />
            <div className=' space-y-5 py-8'>
              <h2 className='text-green-800/100 text-xl font-bold tracking-wider'>
                FREQUENTLY ASKED QUESTIONS
              </h2>
              <div>
                <Dropdown />
              </div>
              {/* <div x-data="{ isOpen: false} " className="my-3">
          <div className="flex justify-between  bg-[#dcae96]  p-4 rounded-md shadow-md">
            <div className="cursor-pointer">What Is Thrive?</div>
            <box-icon name="caret-down" className=" bg-[#295700] rounded-full p-1 text-white shadow-md"/>
          </div>
          <div x-show="isOpen" className="bg-[#D9D9D9] px-4  pt-4 pb-6 rounded-md">
            <p>Thrive is a platform that connects individuals seeking mental health support with licensed and certified
              therapists</p>
          </div>
        </div> */}
              {/* <div x-data="{ isOpen: false} " className="my-3">
          <div className="flex justify-between  bg-[#dcae96]  p-4 rounded-md shadow-md">
            <div className="cursor-pointer  ">How Does Thrive Work?</div>
            <box-icon name="caret-down" className=" bg-[#295700] rounded-full p-1 text-white"/>
          </div>
          <div x-show="isOpen" className="bg-[#D9D9D9] px-4  pt-4 pb-6 rounded-md">
            <p>Users can sign up for an account on our website or mobile app and browse through our list of therapists
              to find one that meets your needs. Your can then book a session with the therapist.</p>
          </div>
        </div> */}
              {/* <div x-data="{ isOpen: false} " className="my-3">
          <div className="flex justify-between  bg-[#dcae96]  p-4 rounded-md shadow-md">
            <div className="cursor-pointer  ">Are There Qualified Therapist?</div>
            <box-icon name="caret-down" className=" bg-[#295700] rounded-full p-1 text-white"/>
          </div>
          <div x-show="isOpen" className="bg-[#D9D9D9] px-4  pt-4 pb-6 rounded-md">
            <p>Yes, all therapists on thrive are licensed and certified mental health professionals.</p>
          </div>
        </div> */}
              {/* <div x-data="{ isOpen: false} " className="my-3">
          <div className="flex justify-between  bg-[#dcae96]  p-4 rounded-md shadow-md">
            <div className="cursor-pointer  ">Is My Information Confidential?</div>
            <box-icon name="caret-down" className=" bg-[#295700] rounded-full p-1 text-white"/>
          </div>
          <div x-show="isOpen" className="bg-[#D9D9D9] px-4  pt-4 pb-6 rounded-md">
            <p>Yes, we take privacy and confidentiality very seriously. All sessions are encrypted and your information
              is protected.</p>
          </div>
        </div> */}
              {/* <div x-data="{ isOpen: false} " className="my-3">
          <div className="flex justify-between  bg-[#dcae96]  p-4 rounded-md shadow-md">
            <div className="cursor-pointer">How Long Does A session Last?</div>
            <box-icon name="caret-down" className=" bg-[#295700] rounded-full p-1 text-white"/>
          </div>
          <div x-show="isOpen" className="bg-[#D9D9D9] px-4  pt-4 pb-6 rounded-md">
            <p>The duration of a standard session is fifty minutes to an hour.</p>
          </div>
        </div> */}
            </div>
          </div>
          <div>
            <div className='flex justify-between mb-6 px-10 bg-[#D4DDCC] pt-5  shadow-lg shadow-[#2A3D19] rounded-md w-[90%] mx-auto '>
              <p>
                Can't find the answer you're looking for? Please chat with our
                friendly team
              </p>
              <Link to='/supportfaq'>
                <button className='rounded-md bg-[#295700] px-4 py-2 mb-6 text-white'>
                  Get in Touch
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Faq;
